import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7f203ebedae7001435b87c_1786728545895_853542e3/msmvportal/src/app/sign-up-login-screen/components/AuthScreen.tsx");
